<template>
  <b-row>
    <b-col md="12">
      <b-card no-body>
        <b-card-body class="text-right">
          <b-button
            to="users/add"
            variant="primary"
          >
            <FeatherIcon icon="PlusIcon" />
            Oluştur
          </b-button>
        </b-card-body>
        <b-card-text>
          <b-table
            responsive="sm"
            :fields="fields"
            :items="dataList"
            striped
          >
            <template #cell(status)="data">
              <b-badge
                v-if="data.item.status === '1'"
                variant="success"
              >
                Aktif
              </b-badge>
              <b-badge
                v-else
                variant="danger"
              >
                Pasif
              </b-badge>
            </template>
            <template #cell(control)="data">
              <b-button
                :to="'/users/edit/' + data.item.id"
                variant="outline-primary"
                size="sm"
              >
                Güncelle
              </b-button>
            </template>
          </b-table></b-card-text>
        <b-card-footer><b-pagination
          v-model="currentPage"
          :total-rows="dataCount"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination></b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BTable, BCardFooter, BPagination, BButton, BBadge, BCardText,
} from 'bootstrap-vue'

export default {
  name: 'Users',
  components: {
    BCard,
    BCardBody,
    BTable,
    BRow,
    BCol,
    BCardFooter,
    BPagination,
    BButton,
    BBadge,
    BCardText,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      search: '',
      fields: [
        {
          key: 'name',
          label: 'Adı Soyadı',
        },
        {
          key: 'email',
          label: 'E-Posta',
          thStyle: { width: '300px' },
        },
        {
          key: 'user_type',
          label: 'Seviye',
          thStyle: { width: '250px' },
        },
        {
          key: 'status',
          label: 'Durum',
          thStyle: { width: '140px' },
        },
        {
          key: 'control',
          label: 'Kontrol',
          thStyle: { width: '140px' },
        },
      ],
      dataQuery: {
        select: [
          'users.id AS id',
          'users.name AS name',
          'users.email AS email',
          'user_types.title AS user_type',
          'users.status AS status',
        ],
        limit: 25,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      const data = this.$store.getters['users/getUsers']
      return data
    },
    dataCount() {
      return this.$store.getters['users/getUsersCount']
    },
  },
  watch: {
    currentPage(val) {
      const page = (val - 1) * 25
      this.pagination(page)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    pagination(page) {
      this.dataQuery.start = page
      if (this.dataQuery.start === page) {
        this.getDataList()
      }
    },
    getDataList() {
      this.$store.dispatch('users/usersList', this.dataQuery)
    },
  },
}
</script>

<style scoped>

</style>
